import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { SeoHead, AnalyticsScripts } from '../seo';
import { pingActivity } from '../shared/services/activity';
import { trackPageview, trackPing, linkAuthToAnalytics } from '../shared/services/analytics/visitorTracker';
import { WELLAND_ACCESS_TOKEN_EVENT } from '../shared/auth/accessTokenEvents';

/** Раздел /admin не трекаем аналитикой (это внутренняя панель). */
const isAdminPath = (p) => p.startsWith('/admin');

/**
 * Общая оболочка маршрутов: SEO, сторонняя аналитика (GA/Yandex),
 * пинг активности залогиненных и собственная аналитика посещений.
 */
export function RootLayout() {
    const location = useLocation();

    // Пинг активности залогиненного (существующий) — смена маршрута/возврат/heartbeat.
    useEffect(() => {
        if (isAdminPath(location.pathname)) return;

        pingActivity();

        const onVisible = () => { if (!document.hidden) pingActivity(); };
        document.addEventListener('visibilitychange', onVisible);
        window.addEventListener('focus', onVisible);

        const heartbeat = setInterval(() => {
            if (!document.hidden) pingActivity();
        }, 2 * 60_000); // каждые 2 минуты, пока вкладка активна

        return () => {
            document.removeEventListener('visibilitychange', onVisible);
            window.removeEventListener('focus', onVisible);
            clearInterval(heartbeat);
        };
    }, [location.pathname]);

    // Собственная аналитика: просмотр страницы на каждую смену маршрута (кроме админки).
    useEffect(() => {
        if (isAdminPath(location.pathname)) return;
        trackPageview(location.pathname);
    }, [location.pathname]);

    // Собственная аналитика: heartbeat времени на сайте, привязка авторизации,
    // финальный ping на выгрузке. Один раз на монтирование.
    useEffect(() => {
        // Уже залогинен при заходе — сразу привяжем; и на будущие логины.
        linkAuthToAnalytics();
        const onToken = () => linkAuthToAnalytics();
        window.addEventListener(WELLAND_ACCESS_TOKEN_EVENT, onToken);

        const pingIfActive = () => {
            if (!document.hidden && !isAdminPath(window.location.pathname)) trackPing();
        };
        document.addEventListener('visibilitychange', pingIfActive);
        const hb = setInterval(pingIfActive, 20_000); // время на сайте — раз в 20с

        const onHide = () => trackPing({ beacon: true }); // надёжно фиксируем последний момент
        window.addEventListener('pagehide', onHide);

        return () => {
            window.removeEventListener(WELLAND_ACCESS_TOKEN_EVENT, onToken);
            document.removeEventListener('visibilitychange', pingIfActive);
            clearInterval(hb);
            window.removeEventListener('pagehide', onHide);
        };
    }, []);

    return (
        <>
            <SeoHead />
            <AnalyticsScripts />
            <Outlet />
        </>
    );
}
